import React, { useState } from 'react';
import { Sprout } from 'lucide-react';

const s = {
  wrapper: {
    minHeight: '100vh',
    background: 'var(--bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'DM Sans, sans-serif',
  },
  card: {
    background: 'var(--card-bg)',
    borderRadius: 16,
    padding: '3rem 2.5rem',
    width: '100%',
    maxWidth: 400,
    textAlign: 'center',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    marginBottom: 8,
  },
  brand: {
    fontFamily: 'Playfair Display, serif',
    fontSize: '1.6rem',
    color: 'var(--text)',
    fontWeight: 700,
  },
  tagline: {
    fontFamily: 'DM Sans, sans-serif',
    fontSize: '0.85rem',
    color: 'var(--secondary)',
    marginBottom: '2rem',
    fontStyle: 'italic',
  },
  subtitle: {
    fontFamily: 'DM Sans, sans-serif',
    fontSize: '0.9rem',
    color: 'var(--text)',
    opacity: 0.7,
    marginBottom: '1.5rem',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: 8,
    border: '1px solid rgba(141,184,122,0.3)',
    background: 'rgba(26,31,26,0.8)',
    color: 'var(--text)',
    fontSize: '1rem',
    fontFamily: 'DM Sans, sans-serif',
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: '1rem',
    transition: 'border-color 0.2s',
  },
  btn: {
    width: '100%',
    padding: '12px',
    borderRadius: 8,
    border: 'none',
    background: 'var(--primary)',
    color: 'var(--bg)',
    fontSize: '1rem',
    fontWeight: 600,
    fontFamily: 'DM Sans, sans-serif',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
  },
  error: {
    color: 'var(--alert)',
    fontSize: '0.85rem',
    marginBottom: '1rem',
    minHeight: 20,
  },
  footer: {
    marginTop: '2rem',
    fontSize: '0.75rem',
    color: 'var(--secondary)',
    opacity: 0.5,
  },
  demoBadge: {
    display: 'inline-block',
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    padding: '3px 10px',
    borderRadius: 20,
    background: 'rgba(141,184,122,0.15)',
    color: 'var(--primary)',
    marginBottom: '1.5rem',
  },
};

export default function Login({ onAuth }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem('demo_auth', data.token || 'authenticated');
        onAuth();
      } else {
        setError('Invalid password. Please try again.');
      }
    } catch {
      // In local dev without auth endpoint, check against hardcoded default
      if (password === 'folioai2026') {
        localStorage.setItem('demo_auth', 'authenticated');
        onAuth();
      } else {
        setError('Invalid password. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.logo}>
          <Sprout size={28} color="var(--primary)" />
          <span style={s.brand}>Folio Coffee Co.</span>
        </div>
        <div style={s.tagline}>Brewed with intention.</div>
        <span style={s.demoBadge}>CRM Intelligence Demo</span>
        <p style={s.subtitle}>Enter password to access the platform</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Enter demo password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={s.input}
            autoFocus
            onFocus={(e) => { e.target.style.borderColor = 'var(--primary)'; }}
            onBlur={(e) => { e.target.style.borderColor = 'rgba(141,184,122,0.3)'; }}
          />
          <div style={s.error}>{error}</div>
          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.6 : 1 }} disabled={loading}>
            {loading ? 'Verifying...' : 'Enter Demo'}
          </button>
        </form>
        <div style={s.footer}>Powered by Hahn AI</div>
      </div>
    </div>
  );
}
